import { Routes, Route } from 'react-router-dom';
import GlobalCustomersPage from './pages/global-customers-page';

export const GlobalCustomersRoutes = () => {
  return (
    <Routes>
      <Route index element={<GlobalCustomersPage />} />
    </Routes>
  );
};
